﻿import { sendDataLayer } from "./ecommerce";

const sendPageView = (urlToSend) =>
{
    if (typeof (urlToSend) === 'undefined' || urlToSend.length == 0)
        urlToSend = document.location.pathname + document.location.search + document.location.hash;

    var hashPart = '';
    var queryPart = '';
    var cleanUrl = urlToSend;
    var hashIndex = cleanUrl.indexOf('#');
    var pageNR = 0;

    if (hashIndex > -1)
    {
        hashPart = cleanUrl.substring(hashIndex);
        cleanUrl = cleanUrl.substring(0, hashIndex);
    }

    var queryIndex = cleanUrl.indexOf('?');

    if (queryIndex > -1)
    {
        queryPart = cleanUrl.substring(queryIndex + 1);
        cleanUrl = cleanUrl.substring(0, queryIndex);
    }

    if (queryPart.length > 0)
    {
        //clean the query
        var newQuery = '';
        var parts = queryPart.split('&');

        if (parts.length > 0)
        {
            for (let i = 0; i < parts.length; i++)
            {
                var currentPart = parts[i];
                var splitPair = currentPart.split('=');

                var key = splitPair[0].toLowerCase();
                var value = '';

                if (splitPair.length > 1)
                    value = splitPair[1];

                if (key == 'page')
                {
                    pageNR = parseInt(value);
                    newQuery += "&page=" + value;
                }
                else if (key != 'price-min' && key != 'price-max')
                    newQuery += "&" + key + "=" + value;
            }
        }

        if (newQuery.length > 0)
            queryPart = '?' + newQuery.substring(1);
        else
            queryPart = '';
    }

    if (queryPart.indexOf("productfeed") > 0 || hashPart.indexOf("productfeed") > 0)
        hashPart = "";

    if (hashPart.indexOf("keuzehulp") > 0)
        hashPart = "";

    cleanUrl += queryPart + hashPart;

    if (lastVirtualPageViewSend != null && lastVirtualPageViewSend == cleanUrl)
        return;

    lastVirtualPageViewSend = cleanUrl;

    sendDataLayer({
        'url': cleanUrl,
        'event': 'virtualPageview'
    });
}

(window as any).sendPageView = sendPageView;

var lastVirtualPageViewSend = null;
const sendToGoogleAnalytics = (item) =>
{
    var name = item['name'];
    var delta = item['delta'];
    var id = item['id'];
    var webVitalValue = name === 'CLS' ? delta * 1000 : delta;

    sendDataLayer({
        'event': 'coreWebVitals',
        'webVitalsMeasurement': {
            'name': name,
            'id': id,
            'value': webVitalValue,
            'delta': delta,
            'valuerounded': Math.round(webVitalValue),
            'deltarounded': Math.round(delta)
        }
    });
}

declare const webVitals: any;

export const sendWebVitals = () =>
{
    try
    {
        // Check if undefined, since an AdBlocker may block web vitals from loading in.
        if (typeof (webVitals) !== typeof (undefined))
        {
            webVitals.onCLS(sendToGoogleAnalytics);
            webVitals.onINP(sendToGoogleAnalytics);
            webVitals.onLCP(sendToGoogleAnalytics);
            webVitals.onFCP(sendToGoogleAnalytics);
            webVitals.onTTFB(sendToGoogleAnalytics);
        }
    }
    // Empty catch to ensure everything else still works.
    catch { }
}
(window as any).sendWebVitals = sendWebVitals;